import { render, staticRenderFns } from "./Selos.vue?vue&type=template&id=3fd60ab0&scoped=true&"
import script from "./Selos.vue?vue&type=script&lang=js&"
export * from "./Selos.vue?vue&type=script&lang=js&"
import style0 from "./Selos.vue?vue&type=style&index=0&id=3fd60ab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd60ab0",
  null
  
)

export default component.exports